// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import Complaints from './pages/Complaints';
import PaySlip from './pages/PaySlip';
import Testimonials from './pages/Testimonials';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Footer from './pages/Footer';

import ReportReviewChecklist from './pages/ReportReviewChecklist';
import Employees from './pages/Employees';
import InspectorsList from './pages/InspectorsList';

// New Report Pages
import UdayamRegistrationCertificate from './pages/UdayamRegistrationCertificate';
import RegistrationCertificate from './pages/RegistrationCertificate';
import LRQAFlashReport from './pages/LRQAFlashReport';
import LRQAInspectionReleaseNote from './pages/LRQAInspectionReleaseNote';
import LRQAInspectionReport from './pages/LRQAInspectionReport';

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/complaints" element={<Complaints />} />
        <Route path="/pay-slip" element={<PaySlip />} />
        <Route path="/report-review-checklist" element={<ReportReviewChecklist />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/inspectors-list" element={<InspectorsList />} />

        {/* New Report Routes */}
        <Route path="/udayam-registration-certificate" element={<UdayamRegistrationCertificate />} />
        <Route path="/registration-certificate" element={<RegistrationCertificate />} />
        <Route path="/lrqa-flash-report" element={<LRQAFlashReport />} />
        <Route path="/lrqa-inspection-release-note" element={<LRQAInspectionReleaseNote />} />
        <Route path="/lrqa-inspection-report" element={<LRQAInspectionReport />} />

        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
